import type { HttpClient } from '~/shared/api'
import type { LoggerFactory } from '~/shared/interfaces'
import { DigitalLectureMainService } from './DigitalLectureMainService'
import { DigitalLectureDetailService } from './DigitalLectureDetailService'
import { DigitalLectureSpeakerAppService } from './DigitalLectureSpeakerAppService'
import { DigitalLectureCoursesService } from './DigitalLectureCoursesService'

export { default as DigitalLectureSpeakerForm, speakerTypes } from './DigitalLectureSpeakerForm'
export type { SpeakerType } from './DigitalLectureSpeakerForm'

export class DigitalLectureService {
  readonly main: DigitalLectureMainService
  readonly detail: DigitalLectureDetailService
  readonly speakerApp: DigitalLectureSpeakerAppService
  readonly courses: DigitalLectureCoursesService

  constructor(http: HttpClient, createLogger: LoggerFactory) {
    this.main = new DigitalLectureMainService(http)
    this.detail = new DigitalLectureDetailService(http, createLogger('DigitalLectureDetailService'))
    this.speakerApp = new DigitalLectureSpeakerAppService(http)
    this.courses = new DigitalLectureCoursesService(
      http,
      createLogger('DigitalLectureCoursesService')
    )
  }
}
